module.exports = " <div class=locale-settings-fieldtype-wrapper> <grid-fieldtype :data=data :config=gridConfig></grid-fieldtype> <div class=\"alert alert-danger mt-16\" v-if=shouldShowIndexPhpWarning> <small v-html=\"translate('cp.settings_locales_index_php_warning', { locale: firstLocale })\"></small> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/LocaleSettingsFieldtype.vue
// module id = 696
// module chunks = 0